import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function PMGetPartnerCommentAttachmentService(token,data) {
    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/PMGetPartnerCommentAttachment`, data,{
    headers: {
        'Authorization': token,
    }
    }).then(res => {
        // notify.NotifySuccess("Your task has been generated successfully. Thank You!");       
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while fetching comments and attachments. please try again later.");
        return false;
    });
}

export default PMGetPartnerCommentAttachmentService;